import { Grid, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import IconPen from "app/common/Icon/IconPen";
import { REGISTER_PRODUCT_TAB } from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import RegisterProductPopup from "../RegisterProductTab/Popup/RegisterProductPopup";
const ListProductDrugBlock = ({
  initialPatient,
  setCurrentTab,
  handleAfterSubmit,
}) => {
  const {
    openCreateOrEditProductPopup,
    handleOpenCreateOrEditCardPopup,
    handleCloseCreateOrEditProductPopup,
    saveOrUpdateRegisterProduct,
    initRegisterProduct,
    resetPopupStore,
  } = useStore().patientManagementStore.registerProductStore;
  const { listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  const isBranchManager = isRoleBranchManager();
  const isRoleSalesConsultant = isSalesConsultant();
  const isCashier = isRoleCashier();
  const isAdminRole = isAdmin();

  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";

  const isEdit =
    ((isAdminRole || isBranchManager || isCashier || isRoleSalesConsultant) &&
      !isInDetailPage) ||
    (isInDetailPage && isAdminRole);
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Sản phẩm</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <p
              className="button-more"
              onClick={() => {
                if (isInDetailPage) {
                  setCurrentTab(3);
                } else {
                  setCurrentTab(REGISTER_PRODUCT_TAB);
                }
              }}
            >
              Xem thêm
            </p>
          </div>
        </Grid>
        {(initialPatient?.drugList || []).length > 0 ? (
          (initialPatient?.drugList || []).map((row, index) => (
            <>
              <Grid
                key={index}
                item
                xs={12}
                style={{
                  borderBottom: "1px solid gray",
                  padding: "5px",
                  fontSize: "var(--fs-base)",
                }}
              >
                <div className="medical-container">
                  <div className="text-medical-container">
                    <div>
                      <span className="text-medical">
                        {getDateTime(row?.orderDate)}
                      </span>
                    </div>
                    <div className="flex flex-wrap items-center">
                      <span className="name-medical">
                        {row?.drugName}({formatMoney(row?.price)})
                      </span>

                      <span className="mx-2 text-gray-400">|</span>
                      <div className="flex justify-center items-center">
                        <span>Số lượng:</span>
                        <CloseIcon fontSize="inherit" />
                        <span className="value-medical">
                          {row?.soldQuantity}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center items-center p-2">
                    {isEdit && (
                      <Tooltip title="Chỉnh sửa">
                        <div
                          onClick={() => {
                            handleOpenCreateOrEditCardPopup(row);
                          }}
                        >
                          <IconPen />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
                <div>
                  {row?.staffRevenues?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "4px",
                        fontSize: "var(--fs-base-two)",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="staff-title"
                        style={{
                          fontWeight: "bold",
                          color: "rgb(102, 102, 102)",
                          marginRight: "4px",
                        }}
                      >
                        Nhân viên:
                      </span>
                      {(() => {
                        const seen = new Set();
                        const uniqueStaffs = row.staffRevenues.filter((s) => {
                          const id = s.staff?.id;
                          if (!id || seen.has(id)) return false;
                          seen.add(id);
                          return true;
                        });

                        return uniqueStaffs.map((el, ind) => (
                          <span key={ind} style={{ whiteSpace: "nowrap" }}>
                            <b>{el?.staff?.staffName}</b> –{" "}
                            {formatNumber(el?.percentRevenue)}% –{" "}
                            {formatMoney(el?.actualAmount)}
                            {ind < uniqueStaffs.length - 1 && ","}{" "}
                            {/* dấu , giữa các nhân viên */}
                          </span>
                        ));
                      })()}
                    </div>
                  )}
                </div>
                <div className="flex mt-2">
                  <div>
                    Đã thu:{" "}
                    <b style={{ color: "green" }}>
                      {formatMoney(row?.totalBillPatientPaid || 0)}
                    </b>
                  </div>
                  <span className="mx-2 text-gray-400">|</span>
                  <div>
                    Cần thu:{" "}
                    <b style={{ color: "red" }}>
                      {formatMoney(
                        (row.amountActuallyPaid = row?.priceWithTax
                          ? +row?.price * +row?.soldQuantity -
                            (+row?.discount || 0)
                          : +row?.price * +row?.soldQuantity -
                            (+row?.discount || 0) +
                            (+row?.taxTotal || 0))
                      )}
                    </b>
                  </div>
                </div>
              </Grid>
            </>
          ))
        ) : (
          <div className="flex justify-center items-center w-full mt-5">
            Chưa có dữ liệu
          </div>
        )}
        {!!openCreateOrEditProductPopup && (
          <RegisterProductPopup
            open={!!openCreateOrEditProductPopup}
            handleClose={handleCloseCreateOrEditProductPopup}
            onSubmit={saveOrUpdateRegisterProduct}
            initRegisterProduct={{
              ...initRegisterProduct,
              patientId: initialPatient?.patientInfo?.id,
            }}
            resetPopupStore={resetPopupStore}
            handleAfterSubmit={handleAfterSubmit}
            listVatPercent={listVatPercent}
          />
        )}
      </Grid>
    </div>
  );
};

export default memo(observer(ListProductDrugBlock));
